
import * as L from 'leaflet';

import { default as Map } from'./MapComponent';
import { ImageLayer } from './layers/ImageLayer';
import { GeoJsonLayer } from './layers/GeoJsonLayer';
import { TileLayer } from './layers/TileLayer';

import ShapeType from './PropTypes/ShapeType';

const LatLng = L.LatLng;
const LatLngBounds = L.LatLngBounds;

export { LatLng, LatLngBounds, ShapeType, Map, ImageLayer, GeoJsonLayer, TileLayer };
